import { MockTracer as OTMockTracer, } from 'opentracing';
const MockSpanCtor = new OTMockTracer().startSpan('prototypeGetter')
    .constructor;
class MockSpanWithReferences extends MockSpanCtor {
    constructor() {
        super(...arguments);
        this.references = [];
    }
    addReference(ref) {
        this.references.push(ref);
    }
}
export class MockTracer extends OTMockTracer {
    _allocSpan() {
        return new MockSpanWithReferences(this);
    }
    dumpSpans() {
        return this.report().spans.map(span => ({
            refs: span.references.map(ref => ({
                type: ref.type(),
                spanId: ref.referencedContext().toSpanId(),
                traceId: ref.referencedContext().toTraceId(),
            })),
            tags: span.tags(),
            logs: span._logs.map((log) => {
                if (log.fields.stack)
                    log.fields.stack = 'REPLACED FOR SNAPSHOT';
                return log;
            }),
            operationName: span.operationName(),
        }));
    }
    extract(format, carrier) {
        if (!carrier['X-Cloud-Trace-Context'])
            return null;
        return {
            toSpanId: () => `MOCKED_SPAN_ID ${format} ${JSON.stringify(carrier)}`,
            toTraceId: () => `MOCKED_TRACE_ID ${format} ${JSON.stringify(carrier)}`,
        };
    }
    inject(_context, _format, _carrier) {
        _carrier['X-Cloud-Trace-Context'] =
            'ffffffffffffffffffffffffffffffff/9999999;o=1';
    }
}
//# sourceMappingURL=mock-tracer.js.map